import { Component, OnInit, Inject } from '@angular/core';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { ReturnRequestDet } from '../../../../common/model/ReturnRequestDet';
import { ExcelUtility } from '../../../../common/util/ExcelUtility';
import { ReturnRequestFacade } from '../../../../common/facade/ReturnRequestFacade';
import { ActivatedRoute, NavigationExtras } from '@angular/router';
import { Strings } from '../../../../common/language/strings';
import { res } from '../../../../common/language/text/res';

@Component({
  selector: 'app-return-request-detail',
  templateUrl: './return-request-detail.component.html',
  styleUrls: ['./return-request-detail.component.css']
})
export class ReturnRequestDetailComponent implements OnInit {
  res = res;
  titleReturnRequest = res.ReturnRequest;
  lblApprove = res.Approve;
  lblDownload = res.Download;
  lblOriginStore = res.OriginStore;
  lblRequestDate = res.RequestDate;
  lblReasonForReturn = res.ReasonForReturn;
  lblGender = res.Gender;
  lblStyle = res.Style;
  lblSelectAnOption = res.SelectAnOption;
  lblSearch = res.Search;
  lblBrand = res.Brand;
  lblStyleVariety = res.StyleVariety;
  lblSize = res.Size;
  lblRequested = res.Requested;
  lblApprovedQuantity = res.ApprovedQuantity;
  lblApproval = res.Approval;
  lblSent = res.Sent;

  isSpanish = true;
  language = 0;

  _storeId: number;
  _reasonId: number;
  _organizationId: string;
  public extras: NavigationExtras;
  public path = 'return/return-request';

  messagesTable: any = {
    emptyMessage: '',
    totalMessage: ''
  };

  loading = false;
  messageLoader = '';
  // alert
  alerts = [];
  // table
  rows: ReturnRequestDet[];
  _filteredData: ReturnRequestDet[];
  editing = {};
  // Filtros
  gender = '-1';
  genders = [];
  style = '-1';
  styles = [];

  FolioSAC = '';
  returnRequest: any;
  returnRequestId = '';
  storeOrigin = '';
  requestDate = '';
  reasonReturn = '';
  readonly = true;
    

  constructor(
    @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    private _returnRequestFacade: ReturnRequestFacade,
    private _excel: ExcelUtility,
    private _activatedRoute: ActivatedRoute,
    public strings: Strings
  ) { }

  ngOnInit() {
    this.isSpanish = this.strings.getLanguageIsSpanish();

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    if (!this.isSpanish) {
      this.language = 1;
    }
    const navigation = this._activatedRoute.queryParams.subscribe(params => {
      this._storeId = Number(params['storeId']);
      this._organizationId = params['organization'];

      this.extras = {
          queryParams: {
              'storeId': this._storeId
              , 'organization':this._organizationId
              , 'startDate': params['startDate']
              , 'endDate': params['endDate']
          }
      };
    });
    this.getReturnRequestDet();
  }

  private getReturnRequestDet() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);
    const id = this._activatedRoute.snapshot.paramMap.get('id');
    this.returnRequestId = id;
    this._returnRequestFacade.GetReturnRequestDetail(id, this.language).subscribe(
      response => {
        this.loading = false;
        this.returnRequest = response.data;
        this.storeOrigin = response.data.storeOriginName;
        this.requestDate = response.data.insertedDate;
        this.reasonReturn = response.data.catDetReturnReasonName;
        this.FolioSAC = response.data.folioSAC;
        this.readonly = response.data.approved;
        this.rows = response.data.items;
        this.rows.forEach(element => {
          if (!this.readonly) {
            element.approved = true;
          }
        });
        this._filteredData = response.data.items;
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertCouldNotGetTheRequestDetail), 'danger');
      }
    );

    
  }

  approveRequest() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.SavingInformation);
    this.returnRequest.language = this.language;
      this.returnRequest.approved = true;
      this.returnRequest.folioSAC = this.FolioSAC;
    this.returnRequest.items = this.rows;
    this.returnRequest.items.forEach(x => {
      if (x.approved === false) {
        x.approvedQuantity = 0;
        }
    });

    this._returnRequestFacade.PutReturnRequest(this.returnRequest).subscribe(
      response => {
        this.loading = false;
        if (response.completed) {
          this.addAlert('<strong>' + response.message + '</strong>', 'success');
          this.readonly = true;
        } else {
          this.addAlert('<strong>' + response.message + '</strong>', 'danger');
        }
      },
      error => {
        this.loading = false;
        this.addAlert('<strong>' + error + '</strong>', 'danger');
      }
    );
  }

  // Save excel
  downloadLayout() {
    if (this.rows.length > 0) {
      const data: any = [];
      this.rows.forEach(row => {

        let approvedText = 'Si';
        if (!row.approved) {
          approvedText = 'No';
        }

        const info = {
          [this.strings.GetText(res.Brand)]: row.brand,
          [this.strings.GetText(res.Gender)]: row.gender,
          [this.strings.GetText(res.StyleVariety)]: row.styleVariety,
          [this.strings.GetText(res.Size)]: row.sizeName,
          [this.strings.GetText(res.Requested)]: row.requestQuantity,
          [this.strings.GetText(res.ApprovedQuantity)]: row.approvedQuantity,
          [this.strings.GetText(res.Approval)]: approvedText,
          [this.strings.GetText(res.Sent)]: row.send,

        };
        data.push(info);
      });
      this._excel.exportAsExcelFile(data, this.strings.GetText(res.ReturnRequest) + ': ' + this.returnRequestId);
    } else {
      this.addAlert(this.strings.GetText(res.AlertInfoMustBeLoadedToGenerateTheFile), 'danger');
    }
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  updateValue(event, cell, rowIndex, returnRequestDetId) {
    let str = event.target.value;
    let validate = true;

    if (str.trim() == '') {
      str = 'a';
    }

    for (let index = 0; index < str.length; index++) {
      const charCode = (str.charAt(0).charCodeAt(0));
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        this.editing[rowIndex + '-' + cell] = false;
        validate = false;
      }
    }
    if (validate) {

      this.editing[rowIndex + '-' + cell] = false;
      this.rows.forEach(element => {
        if (element.returnRequestDetId == returnRequestDetId) {
          element.approvedQuantity = Number(event.target.value);
        }
      });
      // this.rows[rowIndex][cell] = Number(event.target.value)
      this.rows = [...this.rows];
    }
  }

  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();
    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredData[0]);
    // assign filtered matches to the active datatable
    this.rows = this._filteredData.filter(function (item) {
        // iterate through each row's column data
        for (let i = 0; i < keys.length; i++) {
            if (item[keys[i]] != null && (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
                return true;
            }
        }
    });
  }

  // añadir alert
  addAlert(message: String, type: String) {
    this.alerts = [];
    this.alerts.push({
      type: type,
      msg: message
    });
  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent): void {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
  }

  valuechange(event) {
    var length = this.FolioSAC.length
    var k;  
    k = event.charCode;  //k = event.keyCode;  (Both can be used)

    //only allow 25 characters, 127 = Del
    if (length == 25 && k != 127) {
      return false;
    }

    return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || /* k == 32 SPACE ||*/ (k >= 48 && k <= 57));
  }

}
